export const parseLocaledString = (localed) => {
  return +localed?.replace(/\s/g, '').replace(/,/g, '.')
}
